import { render, staticRenderFns } from "./MpesaPayments.vue?vue&type=template&id=25ca3d02&scoped=true&"
import script from "./MpesaPayments.vue?vue&type=script&lang=js&"
export * from "./MpesaPayments.vue?vue&type=script&lang=js&"
import style0 from "./MpesaPayments.vue?vue&type=style&index=0&id=25ca3d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca3d02",
  null
  
)

export default component.exports